import { useState } from "react";
import type { Faq } from "@/mocks/siteData";

export default function FaqAccordion({ items }: { items: Faq[] }) {
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200/70 rounded-lg border border-background-200/70 bg-background-100">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <button
              type="button"
              onClick={() => setOpenId(isOpen ? null : item.id)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors hover:bg-background-200/50 md:px-5"
            >
              <span className="flex items-center gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-800">
                  <i className="ri-question-line text-sm" />
                </span>
                <span className="text-sm font-bold text-foreground-900 md:text-base">
                  {item.question}
                </span>
              </span>
              <i
                className={`ri-add-line text-lg text-foreground-600 transition-transform duration-300 ${
                  isOpen ? "rotate-45" : ""
                }`}
              />
            </button>
            <div
              className={`grid transition-all duration-300 ${
                isOpen ? "grid-rows-[1fr] pb-5" : "grid-rows-[0fr]"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-4 text-sm leading-relaxed text-foreground-700 md:px-5 md:pl-14">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}